import { Box } from '@mui/material';

import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { CustomerAuthenticationReportDetailsMetadataResponse } from '../interfaces';
import Filter from '../../../../../../common/reports/actions/utils/filter';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../locales';

interface Props {
  filters: CustomerAuthenticationReportDetailsMetadataResponse;
}

const FiltersSummary = ({ filters }: Props) => (
  <Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.startingDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.from })}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.endDate.label}
          value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.statuses.label}
          value={filters.statuses.length > 0 ? filters.statuses.join(', ') : '< All >'}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.operationIds.label}
          value={filters.operationIds.length > 0 ? filters.operationIds.join(', ') : '< All >'}
        />
      </Box>
    </Box>
    <Box display="flex" mt={2} mb={2}>
      <Box width="50%">
        <Filter
          label={locales.details.customerMsisdn.label}
          value={reportDetailsFilterValuesFormatter(filters.customerMsisdns)}
        />
      </Box>
      <Box width="50%">
        <Filter
          label={locales.details.providerName.label}
          value={reportDetailsFilterValuesFormatter(filters.providerNames)}
        />
      </Box>
    </Box>
  </Box>
);

export default FiltersSummary;
